module.exports = __webpack_public_path__ + "img/img_intro_1_deco3_mb.fa599450.png";